import { AfterViewInit, Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import Splide from '@splidejs/splide';
import { CommonModule } from '@angular/common';
import { ApiService } from '../../service/api.service';

export interface Product {
  name: string;
  price: number;
  image: string;
  description: string;
  load: boolean;
  productID: string;
  suffix?: string;
  quantity?: number;
}

@Component({
  selector: 'app-products',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() products: Product[] = [
    /*
    { name: 'Producto Premium',   price: 299.99, image: 'https://placehold.co/300x300/?text=Producto+1', description: 'Descripción premium' },
    { name: 'Producto Estándar',  price: 199.99, image: 'https://placehold.co/300x300/?text=Producto+2', description: 'Descripción estándar' },
    { name: 'Producto Básico',    price: 99.99,  image: 'https://placehold.co/300x300/?text=Producto+3', description: 'Descripción básica' },
    { name: 'Producto Deluxe',    price: 399.99, image: 'https://placehold.co/300x300/?text=Producto+4', description: 'Descripción deluxe' },
    { name: 'Producto Económico', price: 49.99,  image: 'https://placehold.co/300x300/?text=Producto+5', description: 'Descripción económica' },
     */
  ];
  @Input() isLoading: boolean = false;
  @Input() selectedProductIds: Set<string> = new Set();
  @Output() productSelected = new EventEmitter<Product>();

  private splideInstance: Splide | null = null;
  private isInitialized = false;

  constructor(private apiService: ApiService) {}

  ngAfterViewInit(): void {
    this.initSplide();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['products'] && !changes['products'].firstChange && this.isInitialized) {
      // Esperar un tick para que Angular actualice el DOM
      setTimeout(() => {
        this.destroySplide();
        this.initSplide();
      }, 0);
    }
  }

  ngOnDestroy(): void {
    this.destroySplide();
  }

  private initSplide(): void {
    if (this.splideInstance) {
      this.destroySplide();
    }

    const splideElement = document.querySelector('#splide');
    if (!splideElement) {
      return;
    }

    this.splideInstance = new Splide('#splide', {
      type: 'slide',         // sin loop
      arrows: false,         // sin flechas
      pagination: false,     // sin bullets
      drag: 'free',          // free scroll tipo snap suave
      autoWidth: true,
      snap: true,            // se ancla a cada slide
      gap: '16px',
      perMove: 1,
      speed: 400,
      easing: 'ease-out',
      padding: '2vw',
    });
    
    this.splideInstance.mount();
    this.isInitialized = true;
  }

  private destroySplide(): void {
    if (this.splideInstance) {
      this.splideInstance.destroy();
      this.splideInstance = null;
    }
  }

  formatPrice(price: number) {
    return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(price);
  }

  onProductClick(p: any) {
    if (!this.isLoading) {
      this.productSelected.emit(p);
    }
  }

  loadProducts() {
    this.products.forEach((product) => {
      if(product.load) {
        this.apiService.getProduct(product.productID).subscribe((data: any) => {
          product.name = data.name;
          product.price = data.price;
          product.image = data.photourl;
          product.load = false;
        });
      }
    });
    
    // Reinicializar Splide después de cargar productos para asegurar que se actualice
    
  }

  refreshSplide(): void {
    if (this.isInitialized) {
      setTimeout(() => {
        this.destroySplide();
        this.initSplide();
      }, 100);
    }
  }
}
